<template>
  <div class="myStock">
    <van-tabs v-model="activeName">
      <van-tab title="待盘点" name="待盘点">  
      </van-tab>
      <van-tab title="已盘点" name="已盘点"> 
      </van-tab>
      <van-tab title="待监盘" name="待监盘"> 
      </van-tab>
      <van-tab title="已监盘" name="已监盘"> 
      </van-tab>
    </van-tabs>
        <div class="list-page">
            <List :type="activeName"></List>
        </div>   
  </div>
</template>

<script>
import {  Tab, Tabs } from "vant";
import List from '@/components/list';

export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    List
  },

  data() {
    return {
      activeName: "待盘点",
      listType: 'mine',
      showList: []
    };
  },
  created() {
    let { type } = this.$route.query;
    if (type) {
      // this.$nextTick(() => {
      //   this.stockType = "list";
      //   this.getAsset("id", id);
      // });
      this.activeName = type
    } else {
      this.activeName = "待盘点"
    }
  },
  mounted() {
    this.listType = 'mine'
  },
  methods: {
    }
};
</script>

<style lang="less">
.stock {
  padding: 20px 0 50px 0;

  &-assetDetail {
    padding: 10px 20px;
  }

  &-img {
    margin-left: 20px;
  }

  &-submit {
    text-align: center;
    button {
      padding: 0 50px;
      margin: 20px auto;
    }
  }
}
</style>
